import { render, staticRenderFns } from "./mnst.vue?vue&type=template&id=6bbe444c&"
import script from "./mnst.vue?vue&type=script&lang=js&"
export * from "./mnst.vue?vue&type=script&lang=js&"
import style0 from "./mnst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports